<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			icon="FileTextIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
			:title="$t('SeeDetailedInformation')"
			@click="seeDetailInformation"
		/>
		<feather-icon
			v-if="TimeWindowDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";

export default {
	name: "CellRendererActions",
	computed: {
		TimeWindowDeletePermission() {
			return this.$store.getters.checkPermission("TIME_WINDOW_D");
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/apps/time-window/time-window-edit/" + this.params.data.id).catch(() => {});
		},
		seeDetailInformation() {
			this.$router.push("/apps/time-window/time-window-view/" + this.params.data.id).catch(() => {});
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("TimeWindow.DeleteTimeWindow.Text1") +
					` "${this.params.data.name}"? ` +
					this.$t("TimeWindow.DeleteTimeWindow.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleTimeWindow/deleteById", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("TimeWindow.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("TimeWindow.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
	},
};
</script>
